import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Botão só-ícone do sistema (38×38, raio 11px, hover mix de 8% do texto sobre o fundo — funciona
 * em qualquer superfície, vidro claro/escuro/header): o mesmo desenho dos ícones de ação do
 * cabeçalho (menu.component.css). Nasceu no restyle do assistente para substituir os
 * `.ai-icon-btn` custom; serve a qualquer barra de ações.
 *
 * M4 (review final): `title` não é mais um atributo HTML do `<button>` interno — Chrome nunca
 * mostra o `title` nativo em `<button disabled>`, e é exatamente o caso do botão "Acoplar"
 * desabilitado. `title` agora é o input do `MatTooltip` hospedado no HOST (hostDirectives), que
 * recebe o hover mesmo com o botão interno desabilitado (`.one-icon-btn:disabled` ganha
 * `pointer-events: none`, deixando o hover "vazar" para o host).
 */
@Component({
  selector: 'one-icon-button',
  standalone: true,
  imports: [MatIconModule],
  hostDirectives: [{ directive: MatTooltip, inputs: ['matTooltip: title'] }],
  templateUrl: './one-icon-button.component.html',
  styleUrl: './one-icon-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneIconButtonComponent {
  icon = input.required<string>();
  ariaLabel = input.required<string>();
  disabled = input(false, { transform: booleanAttribute });
  /** Estado "ligado" (ex.: mudo ativo) — fundo na cor da marca a 14%. */
  active = input(false, { transform: booleanAttribute });
  size = input<'sm' | 'md'>('md');
  clicked = output<void>();

  onClick(): void {
    if (this.disabled()) return;
    this.clicked.emit();
  }
}
